import { render, staticRenderFns } from "./ViewInstantMedication.vue?vue&type=template&id=2af380c4&scoped=true"
import script from "./ViewInstantMedication.vue?vue&type=script&lang=js"
export * from "./ViewInstantMedication.vue?vue&type=script&lang=js"
import style0 from "./ViewInstantMedication.vue?vue&type=style&index=0&id=2af380c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af380c4",
  null
  
)

export default component.exports